<template>
  <div class="viewurl-page">

    <el-breadcrumb style="margin-bottom:30px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="first-breadcrumb">{{ $t("SidebarMenu.Menu01") }}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/SPU/Infringements/' + $route.params.Id }">{{ defalutbrand }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('jgjk.s19') }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="viewurl-topinfo" style="min-height:260px">
      <el-row :gutter="15">
        <el-col :span="8">
          <h1>{{ $t('jgjk.s19') }}</h1>
          <ul class="viewurl-topinfo-ul">
            <li><span>{{ $t('jgjk.s15') }}:</span>{{topinfo.name}}</li>
            <li><span>{{ $t('jgjk.s13') }}:</span>{{topinfo.series}}</li>
            <li><span>{{ $t('jgjk.s14') }}:</span>{{topinfo.model}}</li>
            <li><span>{{ $t('jgjk.s16') }}:</span>{{topinfo.type}}</li>
            <li><span>{{ $t('jgjk.s25') }}:</span>{{topinfo.price}}</li>
          </ul>    
        </el-col>
        <el-col :span="8">
          <div class="last7daystrendbox">
            <div class="dashboard-container">
              <PieChart
                chartheight="201px"
                legendtype="vertical"
                chartid="piechartdataid"
                :charttitle="$t('Infringements.t7')"
                :chartdata="piechartdata"
              />
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="last7daystrendbox">
            <div class="dashboard-container">
              <PieChart
                chartheight="201px"
                legendtype="vertical"
                chartid="piechartdataid1"
                :charttitle="$t('Infringements.t8')"
                :chartdata="piechartdata1"
              />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <ViewUrlPageTable />

  </div>
</template>

<script>
import ViewUrlPageTable from '@/components/SPU/Infringements/Links.vue'
import PieChart from '@/components/Charts/ChartPie.vue'
export default {
  components: {
    PieChart,
    ViewUrlPageTable
  },
  data(){
    return{
      subid: this.$route.params.Id,
      skuid: this.$route.params.SkuId,
      defalutbrand: '',
      topinfo:{
        name: '',
        series: '',
        model: '',
        type: '',
        channel: ''
      },
      piechartdata: {},
      piechartdata1: {}
    }
  },
  
  mounted(){
    this.getTopInfo()
    this.getEcommerceDefense()
    this.getPageTopDashboard()
  },

  methods: {

    /**
     * 获取品牌
     */
    getEcommerceDefense: function(){
      let that = this
      let commmerceArr = JSON.parse(localStorage.getItem("commmerce")).val
      for(let i=0; i<commmerceArr.length; i++){
        if(commmerceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = commmerceArr[i].name
        }
      }
    },

    /**
     * 获取总览信息
     */
    getTopInfo: function(){
      let skuinfo = JSON.parse(localStorage.getItem("SPUecommercedefenseviewurl")).val
      let info = {
        name: skuinfo.name,
        series: skuinfo.series,
        model: skuinfo.model,
        type: skuinfo.type,
        taskid: skuinfo.taskid,
        price: skuinfo.price
      }
      this.topinfo = info
    },

    /**
     * 获取表头
     */
    getPageTopDashboard: function(){
      let that = this
      let url = that.API_URL + '/v3/commerce/spudetail/dashboard'
      let data = {
        skuid: that.skuid,
        taskid: that.topinfo.taskid
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPageTopDashboard', rex)
          /**
           * 渲染图表
           */
          let piechannel = rex[1]
          let newpietype = []
          for(let y=0; y<piechannel.length; y++){
            if(piechannel[y].FakeproductTypeCount/1 > 0){
              newpietype.push(piechannel[y])
            }
          }
          let piechannelitem = []
          for(let i=0; i<newpietype.length; i++){
            let _pie = {}
            _pie.value = newpietype[i].FakeproductTypeCount == null ? 0 : newpietype[i].FakeproductTypeCount
            _pie.name = that.setInfringementsType(newpietype[i].FakeproductType).txt
            _pie.itemStyle = {
              color: that.setInfringementsType(newpietype[i].FakeproductType).color
            }
            piechannelitem.push(_pie)
          }
          let ntype = newpietype.map(item => {return item.FakeproductType})
          let narr = []
          for(let x =0; x<ntype.length; x++){
            narr.push(that.setInfringementsType(ntype[x]).txt)
          }
          that.piechartdata = {
            legendData: narr,
            seriesData: piechannelitem
          }

          let piechannel1 = rex[2]
          let newpietype1 = []
          for(let y=0; y<piechannel1.length; y++){
            if(piechannel1[y].productSuggestCount/1 > 0){
              newpietype1.push(piechannel1[y])
            }
          }
          let piechannelitem1 = []
          for(let i=0; i<newpietype1.length; i++){
            let _pie1 = {}
            _pie1.value = newpietype1[i].productSuggestCount == null ? 0 : newpietype1[i].productSuggestCount
            _pie1.name = that.setInfringementsSuggestion(newpietype1[i].productSuggest).txt
            _pie1.itemStyle = {
              color: that.setInfringementsSuggestion(newpietype1[i].productSuggest).color
            }
            piechannelitem1.push(_pie1)
          }
          let ntype1 = newpietype1.map(item => {return item.productSuggest})
          let narr1 = []
          for(let x =0; x<ntype1.length; x++){
            narr1.push(that.setInfringementsSuggestion(ntype1[x]).txt)
          }
          that.piechartdata1 = {
            legendData: narr1,
            seriesData: piechannelitem1
          }

        },
        error: function(response) {
          console.log('getPageTopDashboard', response)
        }
      })      
    },

  }
}
</script>
